// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorPage_wrapper__EQl0D"};